import { useCallback } from 'react';
import { useEditorStore } from '../store/editorStore';

export const useEditorItems = () => {
  const updateItem = useEditorStore((state) => state.updateItem);
  const selectedItemId = useEditorStore((state) => state.selectedItemId);
  const items = useEditorStore((state) => state.items);
  // Lấy item được chọn
  const selectedItem = items.find(item => item.id === selectedItemId);

  // Xử lý cập nhật item
  const handleUpdate = useCallback((updates: Partial<any>) => {
    if (selectedItemId) {
      updateItem(selectedItemId, updates);
    }
  }, [selectedItemId, updateItem]);

  // Xử lý cập nhật style
  const handleStyleUpdate = useCallback((styleUpdates: Partial<any>) => {
    if (selectedItemId && selectedItem) {
      updateItem(selectedItemId, {
        style: { ...selectedItem.style, ...styleUpdates }
      });
    }
  }, [selectedItemId, selectedItem, updateItem]);

  // Xử lý cập nhật từ khóa cho auto-image
  const handleKeywordUpdate = useCallback((value: string) => {
    // Cập nhật từ khóa - cho phép giá trị trống trong quá trình nhập
    handleUpdate({ content: value });
    
    // Chỉ đặt giá trị mặc định nếu người dùng rời khỏi trường nhập và để trống
    if (value.trim() === '') {
      const timeoutId = setTimeout(() => {
        // Kiểm tra lại item hiện tại, tránh closure
        const currentItem = items.find(item => item.id === selectedItemId);
        if (currentItem && currentItem.type === 'auto-image' && currentItem.content.trim() === '') {
          if (selectedItemId) {
            updateItem(selectedItemId, { content: 'thumbnail background' });
          }
        }
      }, 3000); // Tăng thời gian chờ để cho phép người dùng nhập
      
      return () => clearTimeout(timeoutId);
    }
  }, [handleUpdate, items, selectedItemId, updateItem]);

  // Xử lý di chuyển layer
  const handleMoveLayer = useCallback((moveFunction: (id: string) => void) => {
    if (selectedItemId) {
      moveFunction(selectedItemId);
    }
  }, [selectedItemId]);

  return {
    selectedItem,
    handleUpdate,
    handleStyleUpdate,
    handleKeywordUpdate,
    handleMoveLayer
  };
}; 